import React from "react";

const Loader = () => {
  return (
    <div style={styles.loaderContainer}>
      <img src="/Loader.gif" alt="Loading..." style={styles.loader} />
    </div>
  );
};

const styles = {
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    background: "rgba(0, 0, 0, 0.8)",
  },
  loader: {
    width: "300px", // Adjust the size as needed
  },
};

export default Loader;
